import SrcVector from 'ol/source/Vector'
import LayerVector from 'ol/layer/Vector'
import Style from 'ol/style/Style'
import Stroke from 'ol/style/Stroke'
import Fill from 'ol/style/Fill'

export default function() {

    const drawingSource = new SrcVector({ wrapX: false });

    return new LayerVector({
        source: drawingSource,
        style: new Style({
            fill: new Fill({
                color: 'rgba(0, 0, 0, 0)'
            }),
            stroke: new Stroke({
                color: '#0798FF',
                width: 3
            })
        })
    });
}